import { useTranslation } from 'react-i18next';

import { Header } from 'features/my-profile/components/Header';
import { ReturnFromProfileButton } from 'features/my-profile/components/ReturnFromProfileButton';

import { UserLocation } from './components/UserLocation';

export const LocationPage = () => {
  const { t } = useTranslation('myProfile');

  return (
    <div data-testid={'my-profile-location'}>
      <ReturnFromProfileButton />
      <Header data-testid={'location-page-header'}>{t('location.header')}</Header>
      <UserLocation />
    </div>
  );
};
